import { render, staticRenderFns } from "./ExpressCreationAdditional.vue?vue&type=template&id=228c7e14&"
import script from "./ExpressCreationAdditional.vue?vue&type=script&lang=ts&"
export * from "./ExpressCreationAdditional.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports